import { Avatar } from 'components';
import { useMemo } from 'react';

type Props = {
  avatarUrl?: string;
};

/** In-list typing bubble for quick-reply auto responses (avatar + •••). */
const TypingBubble = ({ avatarUrl }: Props) => {
  const dots = useMemo(
    () => [
      '[animation-delay:-0.3s]',
      '[animation-delay:-0.15s]',
      '',
    ],
    [],
  );

  return (
    <div
      className="flex items-start break-all"
      data-testid="quick-reply-typing"
    >
      <div className="w-12">
        <Avatar circle url={avatarUrl} />
      </div>
      <div className="bg-transparent ml-3 rounded-xl border border-neutral-200 max-w-[70%]">
        <div className="px-4 py-3 flex items-center gap-1">
          {dots.map((delayClass, index) => (
            <span
              key={index}
              className={`w-2 h-2 bg-neutral-400 rounded-full animate-bounce ${delayClass}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TypingBubble;
